import EventEmitter from 'wolfy87-eventemitter';

class EventBus extends EventEmitter {
    constructor() {
        super();
    }
}

export default new EventBus();
